import { createReducer } from '@reduxjs/toolkit';
import { Action } from 'modules/types/common';
import * as actions from './actions';
import { CovidScreeningState } from './types';

export const CovidScreeningInitialState: CovidScreeningState = {
  patient: {
    dateOfBirth: '',
    genderType: '',
    cmrn: '',
    ssn: '',
    icentraPersonId: '',
    names: [],
    addresses: [],
    phones: [],
    emails: [],
    userHasNoCellNumber: false
  },
  subscriber: {
    dateOfBirth: '',
    genderType: '',
    names: [],
    addresses: [],
    phones: [],
    emails: []
  },
  questionnaire: {
    Q_Fever: 'No',
    Q_New_or_Worsening_Cough: 'No',
    Q_Shortness_of_Breath_New_or_Worsening: 'No',
    Q_Body_Aches: 'No',
    Q_COVID_Screen_Sore_Throat: 'No',
    Q_COVID_Screen_Runny_Nose: 'No',
    Q_COVID_Screen_Decreased_Smell_or_Taste: 'No',
    Q_Diarrhea: 'No',
    Q_Outbreak_Date_of_Symptoms_Onset: '',
    Q_COVID_Healthcare_Worker_HD_residence: 'No',
    Q_Covid19_Prescreening: 'No',
    Q_Covid_Symptoms_Primary: 'No',
    has_insurance: '',
    Q_attest_to_accurate_and_complete: 'No',
    Q_COVID_Screen_High_Density_Residence: 'No',
    Q_COVID_Screen_Close_Contact: 'No',
    Q_UDOH_Contact_Tracing: 'No',
    Q_Patient_relationship_to_subscriber: '',
    Q_None_of_the_above: 'No',
    Health_Plan_Name: '',
    HealthPlan_state: '',
    HealthPlan_zip_code: '',
    HealthPlan_City: '',
    Health_Plan_ID: '',
    Health_Plan_Address_line_1: '',
    Health_Plan_Address_line_2: '',
    HEALTH_PLAN_COUNTRY: '',
    patient_first_name: '',
    patient_last_name: '',
    patient_middle_name: '',
    patient_cell_number: '',
    patient_alt_number: '',
    patient_dob: '',
    patient_ssn: '',
    patient_sex: '',
    patient_address_1: '',
    patient_address_2: '',
    patient_zip_code: '',
    patient_city: '',
    patient_state: '',
    patient_email: '',
    subscriber_first_name: '',
    subscriber_last_name: '',
    subscriber_dob: '',
    subscriber_sex: '',
    subscriber_phone: '',
    subscriber_address_1: '',
    subscriber_address_2: '',
    subscriber_city: '',
    subscriber_state: '',
    subscriber_zip_code: '',
    subscriber_email: '',
    SUBSCRIBER_FIRST_NAME_ON_CARD: '',
    SUBSCRIBER_MIDDLE_NAME_ON_CARD: '',
    SUBSCRIBER_LAST_NAME_ON_CARD: '',
    MEMBER_NUMBER: '',
    GROUP_NUMBER: '',
    ResponseId: ''
  },
  insuranceCard: [],
  insuranceList: {
    isFetching: false,
    insuranceData: [],
    error: false
  },
  isOTPValidated: false
};

const PrevPatientInitialState = {
  dateOfBirth: '',
  genderType: '',
  cmrn: '',
  ssn: '',
  icentraPersonId: '',
  names: [],
  addresses: [],
  phones: [],
  emails: []
};

export const PrevPatientReducer = createReducer(PrevPatientInitialState, {
  [actions.SET_PREV_PATIENT]: (state, action) => action.payload
});

const CovidScreeningReducer = createReducer(CovidScreeningInitialState, {
  [actions.COVID_SCREENING_CONFIRM]: (state: CovidScreeningState, action: Action) => {
    state.questionnaire = { ...action.payload?.data.questionnaire };
  },
  [actions.COVID_SCREENING_HAS_INSURANCE]: (state: CovidScreeningState, action: Action) => {
    state.questionnaire = { ...action.payload?.data.questionnaire };
  },
  [actions.SET_PATIENT]: (state, action) => {
    state.patient = action.payload;
  },
  [actions.SET_QUESTIONNAIRE]: (state, action) => {
    state.questionnaire = action.payload;
  },
  [actions.SET_INSURANCE_CARD]: (state, action) => {
    state.insuranceCard = action.payload;
  },
  [actions.SET_SUBSCRIBER]: (state, action) => {
    state.subscriber = action.payload;
  },
  [actions.RESET_COVID_SCREENING]: state => CovidScreeningInitialState,
  [actions.GET_LIST_INSURANCE]: (state, action) => {
    state.insuranceList = { ...action.payload, isFetching: true, error: false };
  },
  [actions.GET_LIST_INSURANCE_SUCCESS]: (state, action) => {
    state.insuranceList = {
      insuranceData: action.payload.data.hp_lst,
      isFetching: false,
      error: false
    };
  },
  [actions.GET_LIST_INSURANCE_FAIL]: state => {
    state.insuranceList = { isFetching: false, error: true, insuranceData: [] };
  },
  [actions.SET_ORDER_STATUS]: (state, action) => {
    state.orderStatus = action.payload;
  },
  [actions.SET_OTP_VALIDATION]: (state, action) => {
    state.isOTPValidated = action.payload;
  }
});

export default CovidScreeningReducer;
